import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31333882"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "import-icon zkfont-upload" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "import-text" }, "点击或将文件拖拽到这里上传", -1))
const _hoisted_3 = { class: "import-tips" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "支持扩展名：.xsl", -1))

import type { UploadFile, UploadFiles, UploadInstance, UploadRequestOptions } from 'element-plus'
import { ElLoading, ElMessage } from 'element-plus'
import { computed, ref, toValue, watch } from 'vue'

interface Props {
  data?: Record<string, string | number>
  name?: string
  limit?: number
  visible: boolean
  request: (data: any) => Promise<any>
  refresh: () => Promise<any>
}


export default /*#__PURE__*/_defineComponent({
  ...{ name: 'WidgetImport' },
  __name: 'widget-import',
  props: {
    data: {},
    name: { default: 'file' },
    limit: { default: 1 },
    visible: { type: Boolean, default: false },
    request: {},
    refresh: {}
  },
  emits: ['download', 'update:visible', 'finish'],
  setup(__props: any, { emit: emits }) {

const props = __props;

const files = ref()
const count = ref(0)


const showed = computed<boolean>({
  get: () => props.visible,
  set: (val) => emits('update:visible', val),
})
const loading = ref()
const uploadRef = ref<UploadInstance>()
const onChange = (data: any, list: any[]) => (count.value = list.length) // 上传数量
const onError = (error: any) => console.error(error) // 上传错误

// 取消按钮关闭
function onCancel() {
  count.value = 0
  uploadRef.value?.clearFiles()
}

// 上传成功
function onSubmit() {
  if (count.value <= 0) return ElMessage.warning('请先选择导入文件！')
  loading.value = ElLoading.service({ lock: true, text: '正在导入中...', background: 'var(--el-overlay-color-light)' })
  uploadRef.value?.submit()
}

// 上传成功
function onSuccess(response: any, uploadFile: UploadFile, uploadFiles: UploadFiles) {
  const finish = uploadFiles.every((item: UploadFile) => item.status === 'success')
  if (finish) {
    loading.value?.close()
    emits('update:visible', false)
    emits('finish', files.value)
    uploadRef.value?.clearFiles()
    props?.refresh()
  }
}

function dataFormatter(options: UploadRequestOptions) {
  const { data, name } = props
  const formData = new FormData()
  formData.append(name, options.file)
  if (data) {
    const items = Object.entries(data)
    items.forEach(([key, val]: [string, string | number]) => formData.append(key, String(val)))
  }
  return formData
}

async function httpRequest(options: UploadRequestOptions) {
  if (!props.request) return
  const formData = dataFormatter(options)
  const requestApi = props.request
  try {
    const data = await requestApi(formData)
    files.value = [...(toValue(files.value) ?? []), data]
  } catch (error: any) {
    console.error(error)
  }
}

watch(
  () => props.visible,
  (now: boolean, old: boolean | undefined) => now !== old && (showed.value = now),
  { immediate: true }
)



return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_tri_dialog = _resolveComponent("tri-dialog")!

  return (_openBlock(), _createBlock(_component_tri_dialog, {
    show: showed.value,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((showed).value = $event)),
    size: "mini",
    title: "导入",
    class: "import-mode",
    footer: true,
    "lock-scroll": false,
    onCancel: onCancel,
    onConfirm: onSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_upload, {
        name: _ctx.name,
        data: _ctx.data,
        limit: _ctx.limit,
        "http-request": httpRequest,
        "auto-upload": false,
        "on-change": onChange,
        "on-success": onSuccess,
        "on-error": onError,
        ref_key: "uploadRef",
        ref: uploadRef,
        class: "import-view",
        accept: ".xls,.xlsx",
        multiple: "",
        drag: ""
      }, {
        tip: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              size: "default",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('download')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("模板下载")
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2
        ]),
        _: 1
      }, 8, ["name", "data", "limit"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})